import {LangKeys} from "locales/i18n";

export default {
   [LangKeys.en]: {
       title: "Cookies | Pumpkin Meet",
       description: "",
   },
}